import * as styles from './index.css';
import Divide from '@/components/Divide';
import Contents from './components/Contents/Contents';
import Consideration from './components/Consideration/Consideration';
import ApplyInfo from './components/ApplyInfo/ApplyInfo';
import EventHead from './components/EventHead/EventHead';
import Enter from './components/Enter/Enter';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import CommonError from '@/components/Error/CommonError';
import EventEndedPopup from './components/EventEndedPopup/EventEndedPopup';
import useSetThemeEffect from '@/hooks/useSetThemeEffect';
import RenderIfBridge from '@/components/RenderIfBridge';
import BridgeError from '@/components/Error/BridgeError';
import TokenCheck from '@/components/TokenCheck';

const ApplyEvent = () => {
  useSetThemeEffect('light');

  return (
    <div className={styles.container}>
      <RenderIfBridge fallback={<BridgeError />}>
        <TokenCheck loadingComponent={null}>
          <ErrorBoundary fallback={<CommonError />}>
            <Suspense>
              <EventEndedPopup />
              <EventHead />
              <Divide horizontal={20} />
              <Contents />
              <Consideration />
            </Suspense>
            <ErrorBoundary fallback={null}>
              <Suspense>
                <ApplyInfo />
              </Suspense>
              <Suspense>
                <Enter />
              </Suspense>
            </ErrorBoundary>
          </ErrorBoundary>
        </TokenCheck>
      </RenderIfBridge>
    </div>
  );
};

export default ApplyEvent;
